import { Device } from '../../types';
import { detectDevice } from '../detectDevice';
import { detectOrientation } from '../detectOrientation';
import { getScreenType } from '../getScreenType';

type InitDeviceStore = () => Device;

export const initDeviceStore: InitDeviceStore = () => {
  const { initialDeviceOptions } = window;

  if (window.IS_SSR && initialDeviceOptions) {
    const orientation = detectOrientation();

    return { ...initialDeviceOptions, ...orientation };
  }

  return detectDevice(getScreenType());
};
